export default class SessionDetails {
    constructor(adapter = {
        studentProfile: false
    }) {
        this.studentProfile = adapter.studentProfile;
    }
}